import { useEffect, useState } from "react";
import DashboardLayout from "../Dashboard/DashboardLayout";
import GamesStats from "./components/GamesStats";
import {useDevice} from "../Dashboard/DeviceContext";
import socket from '../socket.js'

function Games(){

    const {selectedDevice, setSelectedDevice} = useDevice({});
    
    const [numberOf,setNumberOf] = useState({oneDay:0,oneWeek:0,oneMonth:0});
  

  useEffect (()=>{
 
    socket.emit ('getNumberOfGame',selectedDevice);
    socket.on ("NumberOfGame",(data)=>{
      setNumberOf(data);
    })
  
   
  },[]);
return (

<DashboardLayout>


<div className="space-y-8">


<div>

<h1 className="
text-3xl
font-bold
text-white
">

مدیریت بازی‌ها

</h1>


<p className="
text-gray-400
mt-2
">

مشاهده آمار و بازی‌های ثبت شده دستگاه

</p>


</div>




<div className="
grid
grid-cols-1
md:grid-cols-3
gap-6
">


<GamesStats

title="بازی‌های امروز"

value = {numberOf.oneDay}

icon="🎮"

type="info"

/>



<GamesStats

title="بازی‌های این هفته"

value={numberOf.oneWeek}

icon="📅"

type="success"

/>



<GamesStats

title="بازی‌های این ماه"

value={numberOf.oneMonth}

icon="🏆"

type="warning"

/>



</div>





<div className="
bg-slate-900
rounded-3xl
border
border-slate-800
h-[500px]
flex
items-center
justify-center
">


<div className="text-center">


<h2 className="
text-2xl
text-cyan-400
font-bold
">

لیست بازی‌ها

</h2>


<p className="
text-gray-400
mt-3
">

جدول بازی‌ها در مرحله بعد اضافه می‌شود

</p>


</div>


</div>



</div>


</DashboardLayout>


)


}


export default Games;
